import React from 'react';
import { GDSCustomizableComponent } from '#src/types.ts';
import { Image } from '#components/image/image.tsx';
import { Box } from '#components/box/box.tsx';

export interface GDSComposableCardMediaProps extends GDSCustomizableComponent {
  mediaSrc?: string;
  mediaAltText?: string;
  mediaHeight?: string;
  mediaLoading?: 'lazy' | 'eager';
}

export const ComposableCardMedia = ({
  mediaSrc,
  mediaAltText,
  mediaHeight = '148px',
  mediaLoading,
  css,
}: GDSComposableCardMediaProps) => (
  <Box className="GDS-composable-card-media" css={css}>
    <Image
      src={mediaSrc}
      alt={mediaAltText}
      css={{
        display: 'block',
        height: mediaHeight,
        objectFit: 'cover',
        objectPosition: 'center',
        borderStartEndRadius: '$card',
        borderStartStartRadius: '$card',
        width: '100%',
      }}
      loading={mediaLoading}
    />
  </Box>
);
